export * from "../ploom/ui-info-circle-solid";
